import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'reakit/Button';
import classNames from 'classnames';

import Spinner from 'components/spinner';

import './style.css';

const ButtonIcon = React.forwardRef(
  ({ className, size, status, icon: Icon, loading, ...rest }, ref) => {
    const customClassName = classNames('button-w-icon', className, `-${size}`, {
      [`-${status}`]: status != null,
      '-loading': loading,
    });
    return (
      <Button {...rest} ref={ref} className={customClassName}>
        {loading ? <Spinner /> : <Icon className="button-icon" />}
      </Button>
    );
  }
);

ButtonIcon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['s', 'm', 'l']),
  status: PropTypes.oneOf(['success', 'warning', 'danger']),
  icon: PropTypes.func,
  loading: PropTypes.bool,
};

ButtonIcon.defaultProps = {
  className: null,
  size: 'm',
  icon: null,
  status: null,
  loading: false,
};

export default ButtonIcon;
